import { useEffect, useContext, useState } from "react";
import { VSFPChartConfig } from "./VSFPChartConfig";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { applyOverrides } from "../../../utils/dataFunctions";
import { config as vsfpChartConfig } from "../../../d3charts/vsfp/config";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { Loader } from "../../../components/loader/Loader";

export const VSFPChart = () => {
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);

  const { vsfp, filter, vsfpFiltered, loading } = lstore;
  const [vsfpConfig, setVsfpConfig] = useState();

  useEffect(() => {
    if (vsfp && vsfp.rawdata.length > 0) {
      const vsfpConfig = applyOverrides(vsfpChartConfig, {
        axes: { y: { label: { text: `Forward ${(+filter.Horizon[0]).toFixed(0)}d Price Return` } } },
      });
      setVsfpConfig(vsfpConfig);

      const fdata = vsfp.rawdata
        .filter((row) => {
          return (
            filter["ModelDate"].includes(row["ModelDate"]) &&
            filter["Ticker"].includes(row["Ticker"]) &&
            filter["Horizon"].includes(row["Horizon"]) &&
            row["FwdPxRet"]
          );
        })
        .map((item) => {
          return {
            ...item,
            "V-Score": +item["V-Score"],
            FwdPxRet: +item["FwdPxRet"].split("%").join(""),
          };
        });

      ldispatch({ type: lactionTypes.SET_VSFP_FILTERED, payload: fdata });
    }
  }, [
    vsfp,
    ldispatch,
    filter,
  ]);

  if (loading) {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  if (!loading && (!vsfp.rawdata || vsfp.rawdata.length === 0)) {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#666",
          fontSize: 14,
        }}
      >
        No data available
      </div>
    );
  }

  return vsfpConfig && vsfpFiltered ? (
    <VSFPChartConfig
      data={vsfpFiltered}
      config={vsfpConfig}
      width={refs.componentSize.current["VSFPChart"].width}
      height={refs.componentSize.current["VSFPChart"].height}
      lRef={refs.vsfp}
      palette={refs.tickerPalette.current}
    />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
